import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function ImportList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        // { key: "select", sortable: false, label: "Select" },
        { key: "module", sortable: false, label: "Module" },
        { key: "file_name", sortable: false, label: "File Name" },
        { key: "completed", sortable: false, label: "Completed" },
        // { key: "mime_type", sortable: false, label: "Mime Type" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalImportList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const importsMetaData = ref([]);
    const importStatusOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalImportList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData();
    });

    const fetchImportList = (ctx, callback) => {
        store
            .dispatch("app-imports/fetchImports", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value
            })
            .then(response => {
                const import_data = response.data.data;
                const { total } = response.data.meta;
                importStatusOption.value = response.data.status;

                callback(import_data);
                totalImportList.value = total;
                importsMetaData.value = import_data;

                let refetch = import_data.filter(
                    (item) => item.completed < 1
                );
                if (refetch.length > 0) {
                    setTimeout(function () { refetchData() }, 5000);
                }
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching imports",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });
                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching imports`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == false) return "danger";
        if (status == true) return "success";
        return "primary";
    };

    return {
        fetchImportList,
        tableColumns,
        perPage,
        currentPage,
        totalImportList,
        importsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        importStatusOption,
        statusFilter
    };
}
